import { useState } from 'react';

const GOOGLE_REVIEW_URL =
  'https://www.google.com/search?sca_esv=369040512b9c6d40&authuser=0&hl=en&gl=in&output=search&q=Teeth+Empire+Dental+clinic&ludocid=3224051165668183452&lsig=AB86z5XEYvciCSCkErucvbYM6hzu#lrd=0x3bcb93d0b79f036f:0x2cbe217413560d9c,1';
const GOOGLE_WRITE_REVIEW_URL =
  'https://www.google.com/search?sca_esv=369040512b9c6d40&authuser=0&hl=en&gl=in&output=search&q=Teeth+Empire+Dental+clinic&ludocid=3224051165668183452&lsig=AB86z5XEYvciCSCkErucvbYM6hzu#lrd=0x3bcb93d0b79f036f:0x2cbe217413560d9c,3';

const testimonials = [
  {
    rating: 5,
    text: 'Sri Maruthi Teeth Empire transformed my smile completely! The cosmetic dentistry work was exceptional. Dr. and the team made me feel comfortable throughout the entire process. Highly recommend for anyone in Kondapur looking for quality dental care.',
    name: 'Priya Sharma',
    treatment: 'Cosmetic Dentistry',
    source: 'google',
    avatar: 'PS',
    timeAgo: '2 weeks ago',
  },
  {
    rating: 5,
    text: 'Best dental clinic in Hyderabad! The root canal treatment was painless and the staff was very professional. The clinic is modern and clean. Worth every penny!',
    name: 'Rajesh Kumar',
    treatment: 'Root Canal Treatment',
    source: 'google',
    avatar: 'RK',
    timeAgo: '1 month ago',
  },
  {
    rating: 5,
    text: 'I was nervous about getting dental implants, but the team at Sri Maruthi Teeth Empire made the experience smooth and comfortable. The results are amazing! My new teeth look and feel natural. Thank you for giving me my confidence back.',
    name: 'Anita Reddy',
    treatment: 'Dental Implants',
    source: 'google',
    avatar: 'AR',
    timeAgo: '3 weeks ago',
  },
  {
    rating: 5,
    text: 'Excellent service and very friendly staff. The teeth whitening treatment gave me instant results. The clinic location at Botanical Garden Road is convenient and easy to find.',
    name: 'Vikram Patel',
    treatment: 'Teeth Whitening',
    source: 'google',
    avatar: 'VP',
    timeAgo: '1 week ago',
  },
  {
    rating: 5,
    text: 'My daughter needed braces and we chose Sri Maruthi Teeth Empire after reading reviews. The orthodontic treatment has been fantastic. The doctors explain everything clearly and the progress has been excellent. Highly satisfied with the care at this Kondapur dental clinic.',
    name: 'Meera Iyer',
    treatment: 'Orthodontics',
    source: 'google',
    avatar: 'MI',
    timeAgo: '2 months ago',
  },
  {
    rating: 5,
    text: 'Professional, caring, and efficient. The preventive care program helped me maintain my oral health. The team is knowledgeable and always available to answer questions. One of the best dental experiences I have had in Hyderabad.',
    name: 'Arjun Nair',
    treatment: 'Preventive Care',
    source: 'google',
    avatar: 'AN',
    timeAgo: '5 days ago',
  },
  {
    rating: 5,
    text: 'I had an emergency dental issue and they accommodated me immediately. The treatment was quick and effective. Grateful for their prompt service and expertise. Truly the best dental clinic near Kondapur.',
    name: 'Sneha Gupta',
    treatment: 'Emergency Care',
    source: 'google',
    avatar: 'SG',
    timeAgo: '3 days ago',
  },
  {
    rating: 5,
    text: 'Got my wisdom tooth extracted here. The procedure was painless and recovery was smooth. The doctor was very patient in explaining the aftercare instructions. Highly recommend Sri Maruthi Teeth Empire for any dental procedure.',
    name: 'Karthik Reddy',
    treatment: 'Tooth Extraction',
    source: 'google',
    avatar: 'KR',
    timeAgo: '1 week ago',
  },
  {
    rating: 5,
    text: 'Visited for a routine dental check-up and was impressed by the hygiene standards and advanced equipment. The scaling and polishing was done very gently. Will definitely continue my dental care here.',
    name: 'Divya Menon',
    treatment: 'Dental Check-up',
    source: 'google',
    avatar: 'DM',
    timeAgo: '4 days ago',
  },
];

function ReviewCard({ review }: { review: typeof testimonials[0] }) {
  return (
    <article className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-shadow">
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-1">
          {Array.from({ length: review.rating }).map((_, i) => (
            <i key={i} className="ri-star-fill text-lg text-yellow-400"></i>
          ))}
        </div>
        <span className="text-xs text-gray-400">{review.timeAgo}</span>
      </div>

      <p className="text-gray-700 text-sm leading-relaxed mb-6">
        &ldquo;{review.text}&rdquo;
      </p>

      <div className="flex items-center gap-3">
        <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full text-teal-600 font-bold flex-shrink-0 text-sm">
          {review.avatar}
        </div>

        <div className="flex-1">
          <div className="font-bold text-gray-900 text-sm">{review.name}</div>
          <div className="text-xs text-gray-500">{review.treatment}</div>
        </div>

        <a
          href={GOOGLE_REVIEW_URL}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="w-8 h-8 flex items-center justify-center cursor-pointer"
          title="View on Google"
        >
          <i className="ri-google-fill text-xl text-gray-400 hover:text-teal-600 transition-colors"></i>
        </a>
      </div>
    </article>
  );
}

export function Testimonials() {
  const [showAll, setShowAll] = useState(false);
  const visibleReviews = showAll ? testimonials : testimonials.slice(0, 6);

  const col1 = visibleReviews.filter((_, i) => i % 3 === 0);
  const col2 = visibleReviews.filter((_, i) => i % 3 === 1);
  const col3 = visibleReviews.filter((_, i) => i % 3 === 2);

  return (
    <section id="testimonials" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-50 px-4 py-2 rounded-full mb-4">
            <span className="text-sm font-semibold text-teal-600">Patient Stories</span>
          </div>

          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-3"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            What Our Patients
          </h2>
          <h3
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Say About Us
          </h3>

          {/* Google Reviews Badge */}
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-4 bg-white px-6 py-4 rounded-2xl shadow-md hover:shadow-lg transition-shadow cursor-pointer border border-gray-100"
          >
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-google-fill text-3xl text-teal-600"></i>
            </div>

            <div className="text-left">
              <div className="flex items-center gap-1.5">
                <span className="text-2xl font-bold text-gray-900">4.9</span>
                <div className="flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-lg text-yellow-400"></i>
                  ))}
                </div>
              </div>
              <span className="text-xs text-gray-500">Based on 300+ Google Reviews</span>
            </div>

            <i className="ri-external-link-line text-gray-400 ml-2"></i>
          </a>
        </div>

        {/* Reviews Grid - Masonry Style */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <div className="space-y-6">
            {col1.map((review, i) => (
              <ReviewCard key={i} review={review} />
            ))}
          </div>

          <div className="space-y-6">
            {col2.map((review, i) => (
              <ReviewCard key={i} review={review} />
            ))}
          </div>

          <div className="space-y-6">
            {col3.map((review, i) => (
              <ReviewCard key={i} review={review} />
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {!showAll && testimonials.length > 6 && (
            <button
              onClick={() => setShowAll(true)}
              className="inline-flex items-center gap-2 px-8 py-3 bg-teal-600 text-white font-semibold rounded-full hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap"
            >
              Show More Reviews
              <i className="ri-arrow-down-line"></i>
            </button>
          )}

          {showAll && (
            <button
              onClick={() => setShowAll(false)}
              className="inline-flex items-center gap-2 px-8 py-3 bg-teal-600 text-white font-semibold rounded-full hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap"
            >
              Show Less
              <i className="ri-arrow-up-line"></i>
            </button>
          )}

          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 border-2 border-teal-600 text-teal-600 font-semibold rounded-full hover:bg-teal-50 transition-all cursor-pointer whitespace-nowrap"
          >
            See All Google Reviews
            <i className="ri-external-link-line"></i>
          </a>

          <a
            href={GOOGLE_WRITE_REVIEW_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-full hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-edit-line"></i>
            Write a Review
          </a>
        </div>
      </div>
    </section>
  );
}
